import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import BackrrLogo from 'assets/backrr_logo.png';
import { navigateToMain } from 'utils/index';

const footerLinkStyle = {
  color: '#667085',
  textDecoration: 'none',
  fontSize: '0.875rem',
  whiteSpace: 'nowrap',
};

const AuthLayout = ({ children }) => {
  const currentIP = window.location.host;
  const linkBase = navigateToMain(null, 'return');
  const { pathname } = useLocation();
  const showLogo = pathname !== '/verification';
  React.useEffect(() => {
    window.document.getElementsByTagName('body')[0].style.background =
      '#FFFDFA';
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFDFA',
      }}
    >
      {/* Centered card */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 4 },
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 462,
            backgroundColor: '#ffffff',

            border: '1px solid #EFEFF2',
            borderRadius: { xs: '16px', sm: '24px' },
            boxShadow: '0 2px 24px rgba(16, 24, 40, 0.06)',
            p: { xs: 3, sm: 6 },
          }}
        >
          {showLogo && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <Box
                component="img"
                src={BackrrLogo}
                alt="Backrr"
                onClick={() => navigateToMain(currentIP)}
                sx={{
                  height: 34,
                  width: 'auto',
                  cursor: 'pointer',
                  display: 'block',
                }}
              />
            </Box>
          )}
          {children}
        </Box>
      </Box>

      {/* Footer */}
      <Box
        component="footer"
        sx={{ borderTop: '1px solid #EAECF0', px: { xs: 2.5, sm: 5 }, py: 2.5 }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1.5, sm: 0 }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            spacing={{ xs: 2, sm: 3 }}
            justifyContent="center"
            flexWrap="wrap"
          >
            <a
              href={linkBase + '/privacy-policy'}
              target="_blank"
              rel="noopener noreferrer"
              style={footerLinkStyle}
            >
              Privacy Policy
            </a>
            <a
              href={linkBase + '/terms-of-use'}
              target="_blank"
              rel="noopener noreferrer"
              style={footerLinkStyle}
            >
              Terms of Use
            </a>
            <a
              href={linkBase + '/contact-us'}
              target="_blank"
              rel="noopener noreferrer"
              style={footerLinkStyle}
            >
              Contact Us
            </a>
          </Stack>
          <Typography
            sx={{ color: '#667085', fontSize: '0.875rem', textAlign: 'center' }}
          >
            © {new Date().getFullYear()} Backrr. All rights reserved.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthLayout;
